import { getLastNdates, getLastNdaysLabel } from "../getLastNdays";
import {
  getActiveBranchIds,
  getBranchInfobyId,
} from "../multipleBranch/getActiveBranchId";

/*
first FUNCTION lineChartForBranches accepts num of days for whic data is to be prepared.
it fetches data from session storage and gets array of active branches and
runs loop for each branch-bId. and then inside loop for every branch
data forwarded to dataExtractor which will filter data
for both 1 and 5 star rating feedback forms for each branch at a time hence called inside
lool. d1 return by data extactor is fed to FUNCTION dataReducerForEachBranch which will
calculate count/ frequecny for both rating

this output of array of output from dataExtractor is fed to FUNCTION linChartFOr bothRatings.
output format from reducer funtion - its done branchwise but finally we need star rating wise data.

 output format 
     obj = {
        branchName : "fdsaf",
        data : [
        {
            date: "11/11",
            count: 5    
        },
        {
            date: "11/11",
            count: 5    
        }  
        ] 
     }

     finnaly array of data returned by dataReducer which was branchwise data
     is fed to FUNCTION lineChartForBothRating. which will format data Star rating wise.
     ex 
      const output = [
    {
      Rating: "1",
      data: [
        {
          branch: "GK",
          bData: [
            { date: "11/11", count: 4 },
            { date: "12/11", count: 10 },
          ],
        },
        {
          branch: "Lajpat",
         ...
        },
      ],
    },
    {
      ...
    },
*/

export function lineChartForBranches(days, data) {
  // console.log(data);
  const branches = getActiveBranchIds(
    JSON.parse(localStorage.getItem("branches"))
  );

  if (data == null || data.length == 0) return null;
  const output = branches.map((bId) => {
    const d1 = dataExtractor(data, days, bId);

    return dataReducerForEachBranch(d1, bId, days);
  });
  // console.log(output);

  // format of output

  /**
   output = [ {date: '08/12',oneRating: 4 , fiveRating:6}]
   */
  const d2 = lineChartForBothRating(output);

  //format for d2

  /**
   d2 = [{rating:1 , data : [ {branch: 'gk' , bData:[{date,count}]}]},
    {rating:5 , data : [ {branch: 'gk' , bData:[{date,count}]}]}]
   */

  return d2;
}

function dataExtractor(data, days, bId) {
  //data is feedback data, we filter data with bId as admin_Id
  // and rating as 1 or 5.

  // we use breakDate so that out for loop stops beyond a date
  // since we need data for certain number of days only.
  let breakDate = new Date(
    getLastNdates(days)[`${getLastNdates(days).length - 1}`]
  );

  const d1 = [];

  for (let i = 0; i < data.length; i++) {
    if (
      data[i].admin_id == bId &&
      (data[i].rating == "5" || data[i].rating == "1")
    ) {
      d1.push(data[i]);
    }

    // we create date so as to compare n decide when to break the loop;
    let dataDate = new Date(data[i].createdAt);

    if (breakDate > dataDate) break;
  }

  return d1;
}

function dataReducerForEachBranch(data, bId, days) {
  /**
     output format 
     obj = {
        branchName : "fdsaf",
        data : [
        {
            date: "11/11",
            count: 5    
        },
        {
            date: "11/11",
            count: 5    
        }  
        ] 
     }
     */

  console.log(data);

  let bname = getBranchInfobyId(bId).name;
  let output1 = {
    branchName: bname,

    ratingData: [],
  };
  let labels = getLastNdaysLabel(days);
  let dates = getLastNdates(days);
  console.log(labels, dates);

  dates.forEach((date, index) => {
    let counter1 = 0;
    let counter5 = 0;
    data.forEach((item) => {
      if (date == item.createdAt.split("T")[0]) {
        if (item.rating == "1") counter1++;
        if (item.rating == "5") counter5++;
      }
    });

    let obj = {
      date: `${labels[index]}`,
      oneRating: counter1,
      fiveRating: counter5,
    };
    output1.ratingData.push(obj);
  });

  return output1;
}

//this function accpets combined data object for 1 n 5 stars rating
// and for all branches..
// here we split the object ot get separate data object for 1star for all
// branches and another one for 5 stars for all branches.

function lineChartForBothRating(data) {
  /**input data format ==
   * [{branchName:"GK",
   * ratingData :[{date,oneRating,fiveRating}]}]
   *
   * required output data format
   
     const output = [
    {
      Rating: "1",
      data: [
        {
          branch: "GK",
          bData: [
            { date: "11/11", count: 4 },
            { date: "12/11", count: 10 },
          ],
        },
        {
          branch: "Lajpat",
         ...
        },
      ],
    },
    {
      ...
    },
  ];
   */

  // outputData will append to about output.data

  // outputDataBdata will append to outputData.bData

  const lineChartData = [
    { rating: "1", data: [] },
    { rating: "5", data: [] },
  ];
  //FOrmat of input data for looping purspose
  //[(d1){branchName:"GK",
  //  ratingData :[(d2){date,oneRating,fiveRating}]}

  // populating for 1 star rating
  data.forEach((d1) => {
    let outputData = {
      branch: "",
      bData: [],
    };
    d1.ratingData.forEach((d2) => {
      let outputDataBdata1 = {};

      outputDataBdata1.date = d2.date;

      outputDataBdata1.count = d2.oneRating;
      outputData.bData.push(outputDataBdata1);
    });
    outputData.branch = d1.branchName;
    //consolelog(d1.branchName);

    lineChartData[0].data.push(outputData);
  });

  // populating data for 5 star rating
  data.forEach((d1) => {
    let outputData = {
      branch: "",
      bData: [],
    };
    d1.ratingData.forEach((d2) => {
      let outputDataBdata1 = {};

      outputDataBdata1.date = d2.date;

      outputDataBdata1.count = d2.fiveRating;
      outputData.bData.push(outputDataBdata1);
    });
    outputData.branch = d1.branchName;

    lineChartData[1].data.push(outputData);
  });

  return lineChartData;
}

//this function Formats data as per requirement by chartjs library
/**
  const data = {
  labels: labels,
  datasets: [
    {
      label: "My First dataset",
      // if NO color is provided it automatically uses colors from colour pallet.
      // backgroundColor: "rgb(109, 109, 109)",
      // borderColor: "rgb(112, 112, 112)",
      data: [0, 10, 5, 2, 20, 30, 45],
    },
    {
      label: "My second dataset",
      // backgroundColor: "rgb(31, 31, 31)",

      data: [10, 15, 5, 20, 20, 28, 42],
    },
  ],
};
 */

export function LineChartForAllBranches(data, starRating) {
  if (data == null || data.data?.length < 1) return null;
  const d1 = data.data;

  const myDlabels = [];
  d1[0].bData.forEach((item) => {
    myDlabels.push(item.date);
  });

  const output = {
    labels: myDlabels,
    datasets: [],
  };
  d1.forEach((item) => {
    const datasetObj = {
      label: "",
      data: [],
    };

    datasetObj.label = item.branch;
    let count = [];
    item.bData.forEach((d) => {
      count.push(d.count);
    });
    datasetObj.data = count;
    output.datasets.push(datasetObj);
  });

  const output1 = {
    labels: [
      "14/11",
      "15/11",
      "16/11",
      "17/11",
      "18/11",
      "19/11",
      "20/11",
      "21/11",
      "22/11",
      "23/11",
      "24/11",
      "25/11",
      "26/11",
      "27/11",
      "28/11",
    ],
    datasets: [
      {
        label: "my String 1",
        data: [2, 3, 5, 6, 3, 5, 6, 3, 5, 6, 3, 5, 6, 3, 5, 6],
      },
      {
        label: "my String 2",
        data: [7, 6, 3, 6, 3, 5, 6, 3, 5, 6, 3, 5, 6, 3, 5, 6],
      },
      {
        label: "my String 3",
        data: [8, 3, 8, 2, 3, 5, 6, 3, 5, 6, 3, 5, 6, 3, 5, 6],
      },
    ],
  };

  return output;
}
